import {
    TrialBalanceDownloadFormatEnum,
    useRepositoryMutation,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';
import { downloadFile } from '@mews-commander/utils';

export const useTrialBalanceDateIntervalSuspenseQuery = () =>
    useRepositorySuspenseQuery('trialBalance', 'getInterval', {});

const useTrialBalanceDownloadMutation = () =>
    useRepositoryMutation('trialBalance', 'download', { onSuccess: (file) => downloadFile(file) });

export const useTrialBalanceDownloadPdfMutation = () => {
    const { mutate, isPending } = useTrialBalanceDownloadMutation();
    const mutateDownloadPdf = (date: string) => mutate({ format: TrialBalanceDownloadFormatEnum.Pdf, date });

    return { mutateDownloadPdf, isPdfDownloadPending: isPending };
};

export const useTrialBalanceDownloadExcelMutation = () => {
    const { mutate, isPending } = useTrialBalanceDownloadMutation();
    const mutateDownloadExcel = (date: string) => mutate({ format: TrialBalanceDownloadFormatEnum.Excel, date });

    return { mutateDownloadExcel, isExcelDownloadPending: isPending };
};
